angular.module('gym.calendar').controller('DailySessionEditRestrictionDetailsCtrl', ["$scope", "$modalInstance", "$state", "event", function($scope, $modalInstance, $state, event) {
  $scope.event = event;
  $scope.goToEvent = function() {
    $modalInstance.close();
    return $state.go('gym.editEvent', {
      eventId: event.first_session_for_today_id
    });
  };
  return $scope.close = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
